import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


Vue.use(VueRouter)

const routes = [
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/groupReserve',
        name: 'groupReserve',
        component: () => import('../views/GroupReserve.vue')
    },
    {
        path: '/selectByDate',
        name: 'SelectByDate',
        component: () => import('../views/SelectByDate.vue')
    },
    {
        path: '/selectBySeat',
        name: 'SelectBySeat',
        component: () => import('../views/SelectBySeat.vue')
    },
    {
        path: '/myReserved',
        name: 'MyReserved',
        component: () => import('../views/MyReserved.vue')
    },
    {
        path: '/bindXh',
        name: 'BindXh',
        component: () => import('../views/BindXh.vue')
    },
    {
        path: '/sug',
        name: 'Sug',
        component: () => import('../views/Sug.vue')
    },
    {
        path: '/',
        name: 'RoomSelect',
        component: () => import('../views/RoomSelect.vue')
    },
    {
        path: '/GymSelect',
        name: 'GymSelect',
        component: () => import('../views/GymSelect.vue')
    },
    {
        path: '/MyReservedGym',
        name: 'MyReservedGym',
        component: () => import('../views/MyReservedGym.vue')
    },
    {
        path: '/BindTeacher',
        name: 'BindTeacher',
        component: () => import('../views/BindTeacher.vue')
    },
    {
        path: '/CancelBind',
        name: 'CancelBind',
        component: () => import('../views/CancelBind.vue')
    },
    {
        path: '/VerifyTeacher',
        name: 'VerifyTeacher',
        component: () => import('../views/VerifyTeacher.vue')
    },
    {
        path: '/TeacherExtendFrom',
        name: 'TeacherExtendFrom',
        component: () => import('../views/TeacherExtendFrom.vue')
    }, {
        path: '/TeacherExtendTo',
        name: 'TeacherExtendTo',
        component: () => import('../views/TeacherExtendTo.vue')
    }, {
        path: '/BindPhoneNumber',
        name: 'BindPhoneNumber',
        component: () => import('../views/BindPhoneNumber.vue')
    },
    {
        path: '/ResetDefault',
        name: 'ResetDefault.vue',
        component: () => import('../views/ResetDefault.vue')
    },
]

const router = new VueRouter({
    routes
})

export default router
